import XButton from "../common/XButton";
import {
   refresherPromptActionsClasses,
   refresherPromptBodyClasses,
   refresherPromptClasses,
   refresherPromptTitleClasses,
} from "./tourClasses";

const TITLE = "Welcome back";
const DEFAULT_BODY = "It has been a while. Want a quick walk through of the case flow again?";
const ACCEPT_LABEL = "Show me";
const DECLINE_LABEL = "No thanks";

const TourRefresherPrompt = ({ onAccept, onDecline, body = DEFAULT_BODY }) => (
   <div className={refresherPromptClasses} role="dialog" aria-label={TITLE}>
      <h2 className={refresherPromptTitleClasses}>{TITLE}</h2>

      <p className={refresherPromptBodyClasses}>{body}</p>

      <div className={refresherPromptActionsClasses}>
         <XButton variant="outlinePrimary" onClick={onDecline}>
            {DECLINE_LABEL}
         </XButton>

         <XButton variant="primary" onClick={onAccept}>
            {ACCEPT_LABEL}
         </XButton>
      </div>
   </div>
);

export default TourRefresherPrompt;
